import { DI } from '@genesislcap/web-core';

export enum Features {
  ForwardCalendarAll = 'ForwardCalendarAll',
}

export interface FeatureFlags {
  isFeatureActivated(feature: Features): boolean;
}

class FeatureFlagsService implements FeatureFlags {
  isFeatureActivated(feature: Features): boolean {
    const currentUrl = window.location.href;
    const queryString = new URL(currentUrl).search;
    const params = new URLSearchParams(queryString);
    return params.has(`feature.${feature}`);
  }
}

export const FeatureFlags = DI.createInterface<FeatureFlags>((x) =>
  x.singleton(FeatureFlagsService),
);
